import { render, staticRenderFns } from "./ContactInfoRow.vue?vue&type=template&id=f5a89ef0&scoped=true&"
import script from "./ContactInfoRow.vue?vue&type=script&lang=js&"
export * from "./ContactInfoRow.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfoRow.vue?vue&type=style&index=0&id=f5a89ef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a89ef0",
  null
  
)

export default component.exports